import BaseApi from 'api/BaseApi';
import { FormLayoutData } from 'api/types';

export interface ISimplifiedIntermediaryParams {
  id: string;
  variables: FormLayoutData;
}

export interface IIntermediaryApi {
  getIntermediary(): Promise<ISimplifiedIntermediaryParams>;
}

export default class IntermediaryRestApi extends BaseApi implements IIntermediaryApi {
  public getIntermediary(): Promise<ISimplifiedIntermediaryParams> {
    return this.fetch('/intermediary/current');
  }
}
